import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/group-setup/payout-wallets.md?raw';

const GroupSetupPayoutWallets: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default GroupSetupPayoutWallets;
